<template>
    <div class="col-md-12 px-0 py-0">
        <div class="col-md-12">
            <div class="col-md-12 text-right text-success">
                <span style="font-size: 20px">Sección exito</span>
            </div>
        </div>

        <form action="" method="post" class="form-horizontal mt-5">
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Titulo</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="title"
                        class="form-control"
                        placeholder="Titulo"
                    />
                    <span v-if="allerrors.title" :class="['show-error']">{{
                        allerrors.title[0]
                    }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Descripcion</label
                >
                <div class="col-md-9">
                    <ckeditor
                        :editor="editor"
                        v-model="summary"
                        :config="editorConfig"
                    ></ckeditor>
                    <span v-if="allerrors.summary" :class="['show-error']">{{
                        allerrors.summary[0]
                    }}</span>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Texto boton</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="button_text"
                        class="form-control"
                        placeholder="Texto boton"
                    />
                    <span
                        v-if="allerrors.button_text"
                        :class="['show-error']"
                        >{{ allerrors.button_text[0] }}</span
                    >
                </div>
            </div>

            <div class="form-group row">
                <label
                    class="col-md-3 form-control-label"
                    for="text-input"
                ></label>
                <div class="col-md-9">
                    <div id="fine-uploader-manual-trigger"></div>
                    <span v-if="allerrors.image" :class="['show-error']">{{
                        allerrors.image[0]
                    }}</span>
                    <a
                        v-if="image_path"
                        :href="image_path"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Ver imagen</a
                    >
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-3"></div>
                <div class="col-md-9">
                    <div id="fine-uploader-manual-trigger-webp"></div>
                    <span v-if="allerrors.image_webp" :class="['show-error']">{{
                        allerrors.image_webp[0]
                    }}</span>
                    <a
                        v-if="image_webp_path"
                        :href="image_webp_path"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Ver imagen</a
                    >
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Alt image</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="text_image_alt"
                        class="form-control"
                        placeholder="Alt image"
                    />
                    <span
                        v-if="allerrors.text_image_alt"
                        :class="['show-error']"
                        >{{ allerrors.text_image_alt[0] }}</span
                    >
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" @click="update()" class="btn btn-primary">
                    Actualizar
                </button>
            </div>
        </form>
        <template-uploader></template-uploader>
        <template-uploader
            template_id="qq-template-manual-trigger-webp"
            text_button="Imagen webp"
        ></template-uploader>
    </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import qq from "fine-uploader";
import "fine-uploader/fine-uploader/fine-uploader-new.min.css";
export default {
    data() {
        return {
            title: null,
            summary: null,
            button_text: null,
            image: null,
            image_webp: null,
            text_image_alt: null,
            image_path: null,
            image_webp_path: null,
            allerrors: {
                title: null,
                summary: null,
                button_text: null,
                image: null,
                image_webp: null,
                text_image_alt: null,
            },
            editor: ClassicEditor,
            editorConfig: {
                toolbar: ["bold", "italic", "underline"],
            },
        };
    },
    methods: {
        getModel() {
            let me = this;
            axios
                .get("/api/sections?section=doubt exitoso")
                .then(function (response) {
                    me.title = response.data.title;
                    me.summary = response.data.summary;
                    me.button_text = response.data.button_text;
                    me.image = response.data.image;
                    me.image_webp = response.data.image_webp;
                    me.text_image_alt = response.data.text_image_alt;
                    me.image_path = response.data.image_path;
                    me.image_webp_path = response.data.image_webp_path;

                    me.clearError();
                })
                .catch(function (error) {});
        },
        update() {
            let me = this;
            const authUserId = document.querySelector('meta[name="x-user"]').content;
            if (me.validForm()) {
                axios
                    .put(`/api/sections?section=doubt exitoso&key=${authUserId}`, {
                        summary: me.summary,
                        title: me.title,
                        button_text: me.button_text,
                        image: me.image,
                        image_webp: me.image_webp,
                        text_image_alt: me.text_image_alt,
                    })
                    .then(function (response) {
                        me.image_path = response.data.image_path;
                        me.image_path_webp = response.data.image_path_webp;
                        me.clearError();
                        me.showActionSuccess();
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        showActionSuccess() {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: "Actualizacion exitosa!",
            });
        },
        validForm() {
            let me = this;
            let valid = true;

            if (!me.title) {
                me.allerrors.title = ["El campo título es obligatorio."];
                valid = false;
            } else if (me.title.length > 100) {
                me.allerrors.title = [
                    "El campo título debe tener máximo 100 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.title = [""];
            }

            if (!me.summary) {
                me.allerrors.summary = ["El campo resumen es obligatorio."];
                valid = false;
            } else if (me.summary.length > 190) {
                me.allerrors.summary = [
                    "El campo resumen debe tener máximo 190 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.summary = [""];
            }

            if (!me.button_text) {
                me.allerrors.button_text = ["El campo resumen es obligatorio."];
                valid = false;
            } else if (me.button_text.length > 15) {
                me.allerrors.button_text = [
                    "El campo resumen debe tener máximo 15 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.button_text = [""];
            }
            if (!me.image) {
                me.allerrors.image = ["El campo imagen es obligatorio."];
                valid = false;
            }

            if (me.text_image_alt && me.text_image_alt.length > 190) {
                me.allerrors.text_image_alt = [
                    "El campo image alt debe tener máximo 190 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.text_image_alt = null;
            }

            return valid;
        },
        clearError() {
            let me = this;
            me.allerrors = {
                title: null,
                summary: null,
                button_text: null,
                image: null,
                image_webp: null,
                text_image_alt: null,
            };
        },
        getUploadImageUrl() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/upload-image`;
        },
        getDeleteFileUrl() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/delete-file`;
        },
    },
    mounted() {
        let me = this;
        if (me.model_id == 0) {
            me.action = "/api/doubts";
            new qq.FineUploader({
                element: document.getElementById(
                    "fine-uploader-manual-trigger"
                ),
                request: {
                    endpoint: this.getUploadImageUrl(),
                },
                deleteFile: {
                    enabled: true, // defaults to false
                    endpoint: this.getDeleteFileUrl(),
                },
                template: "qq-template-manual-trigger",
                validation: {
                    allowedExtensions: ["jpeg", "jpg", "png", "svg"],
                    itemLimit: 1,
                    sizeLimit: 20971520,
                },
                messages: {
                    noFilesError: "Seleccione una imagen.",
                },
                callbacks: {
                    onComplete: function (id, name, response) {
                        if (response.success) {
                            me.allerrors["image"] = null;
                            me.image = response.path;
                        } else {
                            me.allerrors["image"] = ["Error en la imagen"];
                        }
                    },
                    onDeleteComplete: function (id, name, response) {
                        me.allerrors["image"] = null;
                        me.image = "";
                    },
                },
                multiple: false,
            });
            new qq.FineUploader({
                element: document.getElementById(
                    "fine-uploader-manual-trigger-webp"
                ),
                request: {
                    endpoint: this.getUploadImageUrl(),
                },
                deleteFile: {
                    enabled: true, // defaults to false
                    endpoint: this.getDeleteFileUrl(),
                },
                template: "qq-template-manual-trigger-webp",
                validation: {
                    allowedExtensions: ["webp"],
                    itemLimit: 1,
                    sizeLimit: 20971520,
                },
                messages: {
                    noFilesError: "Seleccione una imagen de tipo webp.",
                },
                callbacks: {
                    onComplete: function (id, name, response) {
                        if (response.success) {
                            me.allerrors["image_webp"] = null;
                            me.image_webp = response.path;
                        } else {
                            me.allerrors["image_webp"] = ["Error en la imagen"];
                        }
                    },
                    onDeleteComplete: function (id, name, response) {
                        me.allerrors["image_webp"] = null;
                        me.image_webp = "";
                    },
                },
                multiple: false,
            });
        } else {
            this.getModel();
            me.action = "/admin/doubt/update/" + me.model_id;
            new qq.FineUploader({
                element: document.getElementById(
                    "fine-uploader-manual-trigger"
                ),
                request: {
                    endpoint: this.getUploadImageUrl(),
                },
                template: "qq-template-manual-trigger",
                validation: {
                    allowedExtensions: ["jpeg", "jpg", "png", "svg"],
                    sizeLimit: 20971520,
                },
                messages: {
                    noFilesError: "Seleccione una imagen.",
                },
                callbacks: {
                    onComplete: function (id, name, response) {
                        if (response.success) {
                            me.allerrors["image"] = null;
                            me.image = response.path;
                        } else {
                            me.allerrors["image"] = ["Error en la imagen"];
                        }
                    },
                },
                multiple: false,
            });
            new qq.FineUploader({
                element: document.getElementById(
                    "fine-uploader-manual-trigger-webp"
                ),
                request: {
                    endpoint: this.getUploadImageUrl(),
                },
                template: "qq-template-manual-trigger-webp",
                validation: {
                    allowedExtensions: ["webp"],
                    sizeLimit: 20971520,
                },
                messages: {
                    noFilesError: "Seleccione una imagen de tipo webp.",
                },
                callbacks: {
                    onComplete: function (id, name, response) {
                        if (response.success) {
                            me.allerrors["image_webp"] = null;
                            me.image_webp = response.path;
                        } else {
                            me.allerrors["image_webp"] = ["Error en la imagen"];
                        }
                    },
                },
                multiple: false,
            });
        }
    },
};
</script>
<style>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}
</style>
